/*
 * The execution of this "base" bundle is deferred, so that it's not render-blocking.
 * That means that we cannot rely on a certain execution order relative to other bundles and scripts.
 *
 * In general, we want to know the dependencies of our pages, so their dependencies should be defined
 * explicitly in the respective page's bundle.
 */
import { getDisyNamespace, isDebug } from '@disy/lib/disy';
import { logger } from '@disy/lib/logging';
import { setupKeynav } from '@disy/lib/setup-keynav';
import { initializeCadenzaStorage } from '@disy/lib/storage-util';
import '@disy/ui/alert';
import '@disy/ui/progress-spinner';

import 'ui/alerts/alerts';
import { setupEllipsis } from 'ui/ellipsis/ellipsis';
import 'ui/sidebar/sidebar';

// Create hotkeys
import { initializeConfiguration } from 'cadenza/config/configuration';
import 'cadenza/header/purpose-of-request-badge/purpose-of-request-badge';
import 'cadenza/header/subnav';
import 'cadenza/header/topnav';
import 'cadenza/hotkeys/hotkey-definitions';
import { postEvent } from 'cadenza/integration/post-message';
import {
  clearPerformanceMetadata,
  setPerformanceMetadata,
} from 'cadenza/performance-analysis/performance-analysis-api';
import { setupSessionPoller } from 'cadenza/session-polling/session-poller';
import 'cadenza/ui/what3words-label/what3words-label';
import { setupKeyboardClick } from 'cadenza/utils/setup-keyboard-click';
import { worksheetLayout } from 'cadenza/workbook/worksheet-layout';

initializeCadenzaStorage();
setupSessionPoller();
setupKeynav();
setupKeyboardClick();
setupEllipsis();
initializeConfiguration();

Object.assign(getDisyNamespace(), {
  postEvent,

  // Used in internal load tests
  setPerformanceMetadata,
  clearPerformanceMetadata,
});

worksheetLayout.setup();
if (isDebug()) {
  document.addEventListener('focusout', (event) => {
    const target = event.target as Element;
    if (!target.closest('.debug-ignore-focus-drop')) {
      // "focusout" is dispatched before the element is removed.
      // So we need to defer the contains() check.

      requestAnimationFrame(() => {
        if (document.activeElement === document.body && !document.body.contains(target)) {
          logger.log(
            'Please fix the focus management of your component: ' +
              'The focus was dropped, because the active element (see below) was removed from the DOM. ' +
              'As a result, the document.body is focused now, which breaks the UX for keyboard users',
            target,
          );
        }
      });
    }
  });
}
